// This icon file is generated automatically.
var MessageSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.05 18.39l2.17-2.1.42.15c1.06.4 2.2.6 3.36.6 4.72 0 8.6-3.36 8.6-7.54 0-4.3-4.01-8.1-8.6-8.1S1.4 5.2 1.4 9.5c0 2.05.91 3.93 2.52 5.33l.02.02.3.26-.07.38-.46 2.68c-.05.32-.02.43-.03.44 0 0 .14-.05.37-.22zm.91 1.06c-.7.53-1.38.72-1.97.38-.6-.34-.79-1-.66-1.88l.4-2.31A8.38 8.38 0 010 9.5C0 4.41 4.66 0 10 0s10 4.41 10 9.5c0 5-4.55 8.94-10 8.94-1.18 0-2.34-.18-3.43-.54l-1.6 1.55zm.27-8.64a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" } }] }, "name": "message-square", "theme": "outlined" };
export default MessageSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/MessageSquareOutlined.js
// module id = 3135
// module chunks = 0